import { container } from "./container";

import { RenderService } from "./render/constants";

export class Application {
    get renderService() {
        return this._renderService || (this._renderService = container.get(RenderService)), 
        this._renderService;
    }
}

export const application = new Application;